export default __webpack_public_path__ + "static/media/18.b6f9a068.jpg";